<section class="wrapper">
  <header class="row">
    <h1 i18n>Account security</h1>
  </header>

  <div class="row">
    <div class="col-xs-12">
      <mat-tab-group>
        <mat-tab label="Login credentials" i18n-label>
          <p i18n>This is how you currently login to risr/advance. Make sure you can always access your
          account by keeping this information up to date.</p>

          @for (loginCredential of loginCredentials(); track loginCredential) {
            <div class="row row-bordered">
              <div class="col-xs-4">
                <div class="label label-info">{{ readableName[loginCredential.type] }}</div>
                <div><strong>{{ loginCredential.username }}</strong></div>
                @if (loginCredential.passwordNotSet) {
                  <div class="label label-warning" i18n>
                    A welcome email will be sent to guide the user through the setup process
                  </div>
                }
              </div>
              <div class="col-xs-8 text-right">
                <ul class="list-inline list-unstyled">
                  @if (canAccessTwoFactorAuth(loginCredential.type)) {
                    <li>
                      @if (isForRemoteUser()) {
                        <a class="btn btn-sm btn-success" [routerLink]="['./', loginCredential.username, 'mfas']"
                          [attr.aria-label]="twoFactorAuthLabel(loginCredential.username)" i18n>Two
                        factor authentication</a>
                      } @else {
                        <a class="btn btn-sm btn-success" [routerLink]="['./', loginCredential.username, 'mfas']"
                          [attr.aria-label]="twoFactorAuthLabel(loginCredential.username)" i18n>Two factor
                        authentication</a>
                      }
                    </li>
                  }
                  @if (canUpdateUsername(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success" (click)="updateUsername(loginCredential)" [attr.aria-label]="editUsernameLabel(loginCredential.username)" i18n>
                        Edit username
                      </button>
                    </li>
                  }
                  @if (canUpdateSSOID(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success" (click)="updateUsername(loginCredential)" [attr.aria-label]="editSSOIDLabel(loginCredential.username)" i18n>
                        Edit SSO ID
                      </button>
                    </li>
                  }
                  @if (canSendPasswordEmail(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success"
                        (click)="sendPasswordEmail(loginCredential)" [attr.aria-label]="sendPasswordEmailLabel(loginCredential.username)" i18n>Send password reset email
                      </button>
                    </li>
                  }
                  @if (canUpdatePassword(loginCredential.type)) {
                    <li>
                      <button class="btn btn-sm btn-success" (click)="updatePassword(loginCredential)" [attr.aria-label]="changePasswordLabel(loginCredential.username)" i18n>
                        Change password
                      </button>
                    </li>
                  }
                  @if (canDelete()) {
                    <li>
                      <button class="btn btn-sm btn-danger" (click)="deleteCredential(loginCredential)" [attr.aria-label]="removeLabel(loginCredential.username)" i18n>
                        Remove
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
          <ul class="mt-4 list-inline list-unstyled">
            @for (type of allowedAccountTypes; track type) {
              <li>
                @if (canCreateCredential(type)) {
                  <button class="btn btn-primary" (click)="addLoginCredential(type)"
                    >Add {{ readableName[type] }} Credential
                  </button>
                }
              </li>
            }
          </ul>
        </mat-tab>

        @if (canAccessAPIKeys()) {
          <mat-tab label="API keys" i18n-label>
            @if (newlyCreatedAPICredential()) {
              <div class="box box-warning">
                <p i18n>
                  <i class="icon-warning"></i><strong>Warning!</strong> Make sure you copy the API
                  credentials below. You won't be able to see them again!
                </p>
              </div>
            }
            @if (newlyCreatedAPICredential()) {
              <div class="box box-info row">
                <div class="col-xs-8">
                  <ul>
                    <li>public_key: {{ newlyCreatedAPICredential()?.public_key }}</li>
                    <li>secret_key: {{ newlyCreatedAPICredential()?.secret_key }}</li>
                  </ul>
                </div>
                <div class="col-xs-4 text-right">
                  <button class="btn btn-info copy-btn" (click)="copyToClipboard()" aria-label="Copy keys" i18n>Copy</button>
                </div>
              </div>
            }
            @for (apiCredential of apiCredentials(); track apiCredential) {
              <div class="row row-bordered">
                <div class="col-xs-8">
                  <div class="label label-info">{{ readableName[apiCredential.type] }}</div>
                  <div><strong>{{ apiCredential.public_key }}</strong></div>
                </div>
                <div class="col-xs-4 text-right">
                  <button class="btn btn-sm btn-danger" (click)="deleteCredential(apiCredential)" [attr.aria-label]="removeLabel(apiCredential.public_key)" i18n>
                    Remove
                  </button>
                </div>
              </div>
            }
            <div class="add-credential">
              <p>
                @if (canCreateCredential(CredentialTypes.API)) {
                  <button class="btn btn-primary" (click)="createApiCredential()" i18n
                    >Add API credential
                  </button>
                }
              </p>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
</section>
